import React, { Component } from "react";

import {
  Box,
  Table,
  TableCell,
  TableRow,
  TableHeader,
  TableBody,
  Image,
  Text,
} from "grommet";
//import firebase from "firebase";
import TaskItemListRow from "./TaskItemListRow";

export class TaskInstanceTaskContainer extends Component {
  state = { subTaskInstance: {}, urlsLoaded: false, urlMaps: [] };

  componentDidMount = () => {
    this.getUrls();
  };

  getUrls = async () => {
    let urlMaps = [];
    const subTaskInstance = this.props.subTaskInstance;

    let takePhotoInstances = this.props.subTaskInstance.TakePhotoInstances;
    const firebase = this.props.firebase;
    let i = 0;
    if (
      typeof takePhotoInstances === "object" &&
      takePhotoInstances.length !== 0
    ) {
      for (const takePhotoInstance of takePhotoInstances) {
        const images = firebase.storage().ref().child("photos/");
        console.log(
          "🚀 ~ file: TaskRowContainer.js ~ line 39 ~ TaskInstanceTaskContainer ~ getUrls= ~ images",
          images
        );
        const image = images.child("thumb_" + takePhotoInstance.Id + ".jpg");
        console.log(
          "🚀 ~ file: TaskRowContainer.js ~ line 41 ~ TaskInstanceTaskContainer ~ getUrls= ~ image",
          image
        );
        const url = await image.getDownloadURL();
        console.log(
          "🚀 ~ file: TaskRowContainer.js ~ line 46 ~ TaskInstanceTaskContainer ~ getUrls= ~ url",
          url
        );
        const newTakePhotoInstance = {
          ...takePhotoInstance,
          URL: url,
        };

        takePhotoInstances[i] = newTakePhotoInstance;
        i++;
      }
    }

    /*
    this.props.subTaskInstance.TakePhotoInstances.forEach(
      (takePhotoInstance, index) => {
        const images = firebase
          .storage()
          .ref()
          .child("photos/");
        const image = images.child("28ba303e-f4ac-467b-b2fb-f4f632fcac85.jpg");
        let url = await image.getDownloadURL(); /*.then(url => {
          const newTakePhotoInstance = {
            ...takePhotoInstance,
            URL: url
          };
          const urlMap = {
            id: takePhotoInstance.Id,
            url: url
          };

          urlMaps.push(urlMap);
          takePhotoInstances[index] = newTakePhotoInstance;
        });
        const newTakePhotoInstance = {
          ...takePhotoInstance,
          URL: url
        };
        const urlMap = {
          id: takePhotoInstance.Id,
          url: url
        };

        urlMaps.push(urlMap);
        takePhotoInstances[index] = newTakePhotoInstance;
      }
    );*/

    const newSubtaskInstance = {
      ...subTaskInstance,
      TakePhotoInstances: takePhotoInstances,
    };

    const newState = {
      ...this.state,
      subTaskInstance: newSubtaskInstance,
      urlMaps: urlMaps,

      urlsLoaded: true,
    };

    this.setState(newState);
  };
  render() {
    if (this.state.urlsLoaded) {
      const titleText =
        "Step " +
        this.props.taskItemCount +
        ": " +
        this.props.subTaskInstance.SubTask.Description;
      return (
        <Box direction="column" alignContent="center">
          <Text alignSelf="center">{titleText}</Text>
          <TaskItemListRow
            urlMaps={this.state.urlMaps}
            subTaskInstance={this.state.subTaskInstance}
          ></TaskItemListRow>
        </Box>
      );
    } else {
      return <Text>Loading...</Text>;
    }
  }
}

export default TaskInstanceTaskContainer;
